import { onpRequest } from "../../util";

class CartStorage {
  static CART_KEY_PREFIX = 'jmco_onp_cart';
  cart_key

  constructor(barId) {
    this.cart_key = `${CartStorage.CART_KEY_PREFIX}_${barId}`;
  }

  // Récupère le cart depuis le localStorage
  _getCart() {
    const stored = localStorage.getItem(this.cart_key);
    return stored ? JSON.parse(stored) : { consumptions: [] };
  }

  // Sauvegarde le cart dans le localStorage
  _saveCart(cart) {
    localStorage.setItem(this.cart_key, JSON.stringify(cart));
  }

  // Met à jour la quantité d'un élément (ajoute si inexistant)
  updateQuantity(id, quantity) {
    const cart = this._getCart();
    const existing = cart.consumptions.find(c => c.id === id);

    if (existing) {
      existing.quantity = quantity;
      if (existing.quantity <= 0) {
        cart.consumptions = cart.consumptions.filter(c => c.id !== id);
      }
    } else {
      cart.consumptions.push({ id, quantity });
    }

    this._saveCart(cart);
  }

  // Récupère la quantité d'un élément
  getQuantity(id) {
    const cart = this._getCart();
    const item = cart.consumptions.find(c => c.id === id);
    return item ? item.quantity : 0;
  }

  // Vide le cart
  clear() {
    this._saveCart({ consumptions: [] });
  }

  // Récupère toutes les consumptions
  getConsumptions() {
    return this._getCart().consumptions;
  }
};

class OrdersStorage {

  static ERROR_DEF_STATUS = ['failed', 'cancelled', 'timeout', 'api_error'];
  static SUCCESS_STATUS = ['success'];

  static ORDERS_KEY_PREFIX = 'jmco_onp_orders';
  static LAST_SEEN_ORDER_KEY_PREFIX = 'jmco_onp_last_seen_order';
  static ORDERS_PENDING_KEY = 'jmco_onp_orders_pending';

  orders_key
  last_seen_order_key
  orders_pending_key

  constructor(eventId) {
    this.orders_key = `${OrdersStorage.ORDERS_KEY_PREFIX}_${eventId}`;
    this.last_seen_order_key = `${OrdersStorage.LAST_SEEN_ORDER_KEY_PREFIX}_${eventId}`;
    this.orders_pending_key = `${OrdersStorage.ORDERS_PENDING_KEY}_${eventId}`;
  }

  // Récupère les orders depuis le localStorage
  _getOrders() {
    const stored = localStorage.getItem(this.orders_key);
    return stored ? JSON.parse(stored) : [];
  }

  // Sauvegarde les orders dans le localStorage
  _saveOrders(orders) {
    localStorage.setItem(this.orders_key, JSON.stringify(orders));
  }

  // Ajoute une nouvelle order
  addOrder(order) {
    if(!order.uid) return;
    const orders = this._getOrders();
    if(orders.find(o => o.uid === order.uid)) return;
    orders.push(order);
    this._saveOrders(orders);
  }

  // Récupère toutes les orders
  getOrders() {
    return this._getOrders();
  }

  // Gère l'ID de la dernière order vuee
  getLastSeenOrder() {
    return localStorage.getItem(this.last_seen_order_key);
  }

  setLastSeenOrder(orderId) {
    localStorage.setItem(this.last_seen_order_key, orderId);
  }

  _getOrdersPending() {
    const stored = localStorage.getItem(this.orders_pending_key);
    return stored ? JSON.parse(stored) : [];
  }

  _saveOrdersPending(orders) {
    //Filter only valid orders with barId and pwlUid and internalId
    const validOrders = orders.filter(o => o.barId && o.pwlUid && o.internalId);
    localStorage.setItem(this.orders_pending_key, JSON.stringify(validOrders));
  }

  addPendingOrder(order) {
    const orders = this._getOrdersPending();
    orders.push({...order, internalId: this.orders_pending_key + '_' + Date.now() + '_' + Math.random()});
    this._saveOrdersPending(orders);
  }

  removePendingOrder(order) {
    const orders = this._getOrdersPending();
    const updatedOrders = orders.filter(o => o.internalId !== order.internalId);
    this._saveOrdersPending(updatedOrders);
  }

  removePendingOrderWithPwlUid(pwlUid) {
    const orders = this._getOrdersPending();
    const updatedOrders = orders.filter(o => o.pwlUid !== pwlUid);
    this._saveOrdersPending(updatedOrders);
  }

  async checkPendingOrders() {
    const pendingOrders = this._getOrdersPending();
    let hasNewOrders = false;
    for(const order of pendingOrders) {
      if(!order.barId || !order.pwlUid) {
        this.removePendingOrder(order);
        continue;
      }
      let response = null;
      try {
        response = await onpRequest(order.barId, '/pwl/' + order.pwlUid + '/status');
      } catch (error) {
        console.error('Error checking pending order status:', error);
      }

      if(response && response.status) {
        if(OrdersStorage.SUCCESS_STATUS.includes(response.status)) {  
          hasNewOrders = true;
          const client = response.client;
          let transaction = null;
          for(const t of client.transactions) {
              if(t.type == "debit") {
                  transaction = t;
              }
          }
          const orderData = {
              uid: client.uid,
              number: transaction.order_number,
              total: transaction.amount,
              createdAt: transaction.date
          }
          this.addOrder(orderData);
          this.removePendingOrder(order);
        } else if(OrdersStorage.ERROR_DEF_STATUS.includes(response.status)) {
          this.removePendingOrder(order);
        }
      }
    }
    return hasNewOrders;
  }
};

class UserStorage {
  static USER_KEY = 'jmco_onp_user';

  static getName() {
    const stored = localStorage.getItem(UserStorage.USER_KEY + '_name');
    return stored ? JSON.parse(stored) : null;
  }

  static setName(name) {
    localStorage.setItem(UserStorage.USER_KEY + '_name', JSON.stringify(name));
  }
}

export { CartStorage, OrdersStorage, UserStorage };